import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/chevron-right.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M8.29302 5.29302C8.68354 4.90249 9.31655 4.90249 9.70708 5.29302L15.7071 11.293C16.0976 11.6835 16.0976 12.3166 15.7071 12.7071L9.70708 18.7071C9.31655 19.0976 8.68354 19.0976 8.29302 18.7071C7.90249 18.3166 7.90249 17.6835 8.29302 17.293L13.586 12L8.29302 6.70708C7.90249 6.31655 7.90249 5.68354 8.29302 5.29302Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as ChevronRightIcon };
